import { useTranslation } from 'react-i18next';
import { FilterAltOutlined as FilterAltOutlinedIcon } from '@mui/icons-material';

import { ToggleButton, type ToggleButtonProps } from '@/components/buttons/ToggleButton';

export const FilterButton = (props: ToggleButtonProps) => {
  const { t } = useTranslation('actions');

  return (
    <ToggleButton {...props} startIcon={<FilterAltOutlinedIcon fontSize="medium" />}>
      {t('filters')}
    </ToggleButton>
  );
};
